export const setInvestorInfo=(data)=>{
    return {
        type: "SET_INVESTOR_INFO",
        info: data,
    }
}
export const nullInvestorInfo=()=>{
    return{
        type:"NULL_INVESTOR_INFO",
        info: null
    }
}
export const getInvestorInfo=()=>{
    return {
        type: "GET_INVESTOR_INFO",
        
    }
}
